import { getAllBusinessDevelopmentUsers } from '@api/services/client-installation.service';
import useDataQuery from '@hooks/use-data-query';

export const useBusinessDevelopmentListData = () => {
    const businessDevelopmentListQuery = useDataQuery(['business-development-user'], () =>
        getAllBusinessDevelopmentUsers()
    );

    return {
        businessDevelopmentUser: businessDevelopmentListQuery.data,
        isLoading: businessDevelopmentListQuery.isLoading,
    };
};
